import AccessList from '@/components/access/AccessList'
/* import AccessEdit from '@/components/access/AccessEdit'
import AccessVue from '@/components/access/AccessVue' */
import AccessCreate from '@/components/access/AccessCreate'

export default [
  {
    path: '/mandats',
    name: 'AccessList',
    component: AccessList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'sector_manager']
    }
  },
  {
    path: '/mandats/creation',
    name: 'AccessCreate',
    component: AccessCreate,
    meta: {
      parentName: 'AccessList',
      requiresAuth: true,
      needProfile: ['admin']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/accessRouter.js